<template>
  <div>

  <ToolBar :title="toolbarTitle" :color="toolbarColor"/>

  <v-content> 
    <ToolBarDate :prazo="prazo" :dias="faltamdias" />
    <transition name="fade">
      <router-view></router-view>
    </transition>
  </v-content>

  <v-bottom-nav :app="true" :value="true" :fixed="true" >
      <v-btn to="dados" color="teal--text">
        <span>Dados</span>
        <v-icon>face</v-icon>
      </v-btn>

      <v-btn to="agradecimentos" color="deep-orange--text">
        <span>Agrad</span>
        <v-icon>favorite</v-icon>
      </v-btn>

      <v-btn to="fotos" color="deep-purple--text">
        <span>Fotos</span>
        <v-icon>photo_camera</v-icon>
      </v-btn>
  </v-bottom-nav>
  </div>
</template>

<script>
import ToolBar from "@/components/ToolBar";
import ToolBarDate from "@/components/ToolBarDate";

import moment from "moment";
moment.locale("pt-BR");
export default {
  name: "AppMain",
  components: {
    ToolBar,
    ToolBarDate
  },
  data() {
    return {
      toolbarTitle: "A5 Convites",
      toolbarColor: "white",
      prazo: "",
      faltamdias: ""
    };
  },
  mounted() {
    this.$auth.onAuthStateChanged(user => {
      if (user) {
        this.user = user;
        let email = user.email;
        this.emailkey = email.replace(/[.]/g, ",");
        const userRef = this.$db.ref(`users/${this.emailkey}`);
        userRef.once("value", snap => {
          this.projeto = snap.val().projeto.atual;
          this.comissao = snap.val().projeto.projetos[this.projeto].comissao;
          let prazo = snap.val().projeto.projetos[this.projeto].prazo;
          this.prazo = moment(prazo, "DD/MM/YYYY").format("DD/MM/YYYY");
          this.prazoTrue = moment(prazo, "DD/MM/YYYY").isAfter(moment());
          this.faltamdias = Math.ceil(
            moment(prazo, "DD/MM/YYYY").diff(moment(), "days", true)
          );
        });
      } else {
        this.$router.replace("/login");
      }
    });
  }
};
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/views/AppMain.vue